var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-card",class:{ titled: _vm.titled, 'no-padding': _vm.noPadding },on:{"click":_vm.eventClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }